import {
  IsNotEmpty,
  IsIn,
  IsNumber,
  IsArray,
  IsOptional,
  ValidateNested,
  IsBoolean,
} from "class-validator";
import { Type } from "class-transformer";

import { Constants } from "@eagerdog/constants";

import { IRallyObedienceScore } from "./rally-obedience-score.interface";
import { ElementDeductionsDto } from "./element-deductions.dto";

export class RallyObedienceScoreDto implements IRallyObedienceScore {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  // @IsNotEmpty()
  // @IsNumber()
  // deductions: number;
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ElementDeductionsDto)
  element_deductions?: ElementDeductionsDto[];

  @IsOptional()
  @IsNumber()
  time?: number;

  @IsOptional()
  @IsBoolean()
  total_deductions_only?: boolean;

  @IsOptional()
  @IsNumber()
  total_deductions?: number;

  // C-WAGS Rally - total score (not deductions)
  @IsOptional()
  @IsNumber()
  total_score?: number;

  @IsOptional()
  @IsBoolean()
  excluded_from_placement?: boolean;
}
